import _ from "lodash";
import React from "react";
import classes from "./FolderItem.scss";
import classNames from "classnames";
import { FolderFilled } from "@toddle-edu/ds-icons";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { Tooltip } from "@toddle-edu/ds-web";
import { isPortfolioAIEnabledAndIsJournalRoute } from "Post/utils";
import { onEnterOrSpaceKeyDown } from "Utils";

const FolderItem = props => {
  const {
    isFolderSelected,
    folderDetails,
    handleFolderChange,
    key,
    folderItemStyle,
    testId,
  } = props;
  const { value: id, label: name, color = "" } = folderDetails;
  const folderClass = classNames({
    [classes.folderContainer]: !isFolderSelected,
    [classes.selectedFolderContainer]: isFolderSelected,
  });

  const handleFolderClick = id => () => handleFolderChange({ folder: id });
  const handleFolderKeyDown = id => e => {
    onEnterOrSpaceKeyDown(e, () => handleFolderChange({ folder: id }));
  };

  const showTooltip = _.size(name) > 25;
  return (
    <div
      className={folderClass}
      onClick={handleFolderClick?.(id)}
      key={key}
      style={folderItemStyle}
      data-test-id={testId}
      tabIndex={0}
      onKeyDown={handleFolderKeyDown?.(id)}
    >
      <div className={classes.leftContainer}>
        {id && (
          <div className={classes.folderIcon}>
            <FolderFilled style={{ color: color }} size="x-small" />
          </div>
        )}
        <ConditionalWrapper
          condition={showTooltip}
          wrapper={<Tooltip tooltip={name} placement={"top"} />}
          type={"wrapperAsElement"}
        >
          <div className={classes.folderText}>{name}</div>
        </ConditionalWrapper>
      </div>
      {isFolderSelected && (
        <div
          className={
            isPortfolioAIEnabledAndIsJournalRoute()
              ? classes.selectedIcon
              : classes.selectedBar
          }
        />
      )}
    </div>
  );
};

export default FolderItem;
